var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcHuawei24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-huawei-24_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#ic-huawei-24_svg__b)",
  d: "M6.52 0C1.586 0-.218 1.803-.218 6.733v10.534C-.217 22.197 1.587 24 6.52 24h10.525c4.933 0 6.74-1.803 6.74-6.733V6.733C23.783 1.803 21.98 0 17.046 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M10.255 13.92h.963l-.483-1.124zm-.238.566-.288.655h-.652L10.46 12h.562l1.379 3.14h-.67l-.288-.655zm10.476.652h.629V12h-.629zm-2.507-1.348h1.153v-.576h-1.153v-.637h1.684V12h-2.307v3.138h2.373v-.577h-1.75zm-2.497.372L14.775 12h-.52l-.714 2.162L12.847 12h-.679l1.096 3.14h.528l.72-2.063.721 2.063h.532l1.08-3.14h-.662zm-7.37-.362c0 .51-.253.784-.72.784s-.721-.28-.721-.805V12H6.04v1.796c0 .884.491 1.391 1.346 1.391s1.36-.516 1.36-1.417V12H8.11zM4.53 12h.636v3.142h-.637v-1.275H3.086v1.275H2.45V12h.637v1.267h1.442zM11.786 8a4.005 4.005 0 0 1-4-4h.564a3.436 3.436 0 0 0 6.872 0h.565a4.005 4.005 0 0 1-4 4"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "ic-huawei-24_svg__b",
  x1: 11.769,
  x2: 11.769,
  y1: 0.036,
  y2: 24.01,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FB6361"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ED3E45"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-huawei-24_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgIcHuawei24;